export enum ESpecialTabs {
  Mortgage = 'mortgage',
  SearchRealtors = 'search_realtors',
  Valuation = 'valuation',
  AddForm = 'add_form',
}
